var settings = {
    selectors: {
        formGroup: '.form-group',
        radioInputs: 'input[type="radio"]',
        descriptions: '[data-description-for]',
        textfield: '[data-extra-info]',
        paginationButton: '[data-pagination-button]',
        paginationBackButton: '[data-pagination-back]',
        singleOptionSelector: '.single-option-selector',
        multiselectMasterInput: '[data-multiselect-master]',

    },
    classes: {
        invalidFieldsAnimation: 'bounce',
        buttonGroupTextfield: 'btn-group__textbox',
    },
    attributes: {
        inputsOptional: 'optional'
    }
};

var Utils = {
    groupBy: function (xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    },
    createTextfield: function ({ name, placeholder }) {
        var $textfield = document.createElement('textarea');
        $textfield.name = name;
        $textfield.placeholder = placeholder;
        $textfield.classList.add(settings.classes.buttonGroupTextfield, 'hidden');
        return $textfield;
    },
    arrayEquals: function (a, b) {
        var coincidences = 0;
        if (!(Array.isArray(a) && Array.isArray(b) && a.length === b.length)) {
            return false;
        }
        a.forEach(function (itemA) {
            b.forEach(function (itemB) {
                if (itemA.toLowerCase().trim() ===
                    itemB.toLowerCase().trim()) {
                    coincidences++;
                }
            })
        });
        return (coincidences === a.length) ? true : false;
    },
    arrayUnique: function (array) {
        var a = array.concat();
        for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1);
            }
        }

        return a;
    }

}

window.GlobalFormState = Object.seal({
    _selectedStyle: null,
    getSelectedStyle: function () {
        if (!this._selectedStyle) {
            return null;
        }
        return this._selectedStyle.split('style-')[1]
    },
    setSelectedStyle: function (style) {
        this._selectedStyle = style;
    },
    _sellingPlanID: null,
    setSellingPlanID: function (id) {
        this._sellingPlanID = id;
    },
    getSellingPlanID: function () {
        return this._sellingPlanID;
    },
    selectedOptions: {
        outfit: [],
        accessories: []
    },
    updateSelectedOptions: function (newOptions) {
        this.selectedOptions = Utils.arrayUnique(this.selectedOptions.concat(newOptions));
        return this.selectedOptions;
    },
    setSelectedOutfitOptions: function (options) {
        this.selectedOptions.outfit = options;
    },
    setSelectedAccessoriesOptions: function (options) {
        this.selectedOptions.accessories = options;
    },
    getSelectedOptions: function () {
        return this.selectedOptions.outfit.concat(this.selectedOptions.accessories);
    }
});

function GroupMux(groups) {

    this.groups = Array.from(groups);

    this.initializeInstance = function (Instance, id) {
        var groupElement = this.groups.find(function (g) { return g.id === id });
        if (!groupElement) {
            return
        }
        Instance.initialize(groupElement);
    }

}

function StyleGroupController() {

    var that = this;

    this.initialize = function (element) {
        this.element = element;
        this.inputElements = Array.from(this.element.querySelectorAll('input[type="radio"]'));
        this.inputControllers = this.inputElements.map(function (input) {
            return new InputController(input)
        });
        this.inputControllers.forEach(function (multiselectInput) {
            multiselectInput.listenToChange(that._handleInputChange.bind(that));
        });
        this._setDefaultActiveInput(this.inputElements[0])
    }

    this._setDefaultActiveInput = function (input) {
        input.checked = true;
        input.dispatchEvent(new CustomEvent('change'));
    }

    this._handleInputChange = function (event) {
        window.GlobalFormState.setSelectedStyle(event.target.id);
        document.dispatchEvent(new CustomEvent('style:selected'));
        this._toggleDescriptions(event.target);
        this._toggleTextfield(event.target);
    }

    this._toggleDescriptions = function (current) {
        this.inputControllers.forEach(function (msi) {
            msi.toggleDescription((msi.element.id === current.id) ? 'open' : 'close');
        });
    }

    this._toggleTextfield = function (current) {
        this.inputControllers.forEach(function (msi) {
            if (msi.element.id === current.id) {
                msi.toggletextfield(current);
            }
        });

    }
}

function SizeGroupController() {

    var that = this;

    this.initialize = function (element) {
        this.element = element;
        this.inputElements = Array.from(this.element.querySelectorAll('input[type="radio"]'));
        this.bottomsInputs = this.inputElements.filter(function (i) {
            return 'containsSubfields' in i.dataset;
        });
        this.legInputs = this.inputElements.filter(function (i) {
            return 'subfields' in i.dataset;
        });
        this.bottomsInputs.forEach(function (input) {
            input.addEventListener('input', that._handleSubinputsValidation.bind(that))
        })
        document.addEventListener(
            'group:switch',
            this._updateDisabledInputs.bind(this)
        );
    }

    this._handleSubinputsValidation = function (e) {
        var inventory = window.mysteryBoxInventory[window.GlobalFormState.getSelectedStyle()];
        if (!inventory) {
            return;
        }
        var optionKey = 'bottom_' + this._getInputOptionWithValue(e.target).value;
        this.legInputs.forEach(function (input) {
            input.checked = false;
            var inputData = that._getInputOptionWithValue(input);
            if (
                inventory &&
                inventory[inputData.option] &&
                inventory[inputData.option][optionKey] &&
                !inventory[inputData.option][optionKey][inputData.value]
            ) {
                input.disabled = true;
            } else {
                input.disabled = false;
            }
        });
    }

    this._updateDisabledInputs = function () {
        var inventory = window.mysteryBoxInventory[window.GlobalFormState.getSelectedStyle()];
        if (!inventory) {
            return;
        }
        this.inputElements.forEach(function (input) {
            var inputData = that._getInputOptionWithValue(input);
            if (
                inventory &&
                inventory[inputData.option] &&
                !inventory[inputData.option][inputData.value] &&
                inputData.option !== 'leg'
            ) {
                input.disabled = true;
            }
        })
    }

    this._getInputOptionWithValue = function (input) {
        var inputData = input.id.split('-');
        var option = inputData[0];
        var groupValue = inputData[inputData.length - 1]
        return {
            option: option,
            value: groupValue
        }
    }
}

function OutfitGroupController(hiddenSection) {

    var that = this;
    this.optionSelector = document.querySelector(settings.selectors.singleOptionSelector)

    this.initialize = function (element) {
        this.element = element
        this.inputs = this.element.querySelectorAll('input[type="radio"]');
        document.addEventListener('group:switch', this._updateVariantSelector.bind(this))
        if(hiddenSection){
            this.inputs.forEach((i)=>{
                i.addEventListener('change', e=>{
                    var sizeRevealerInputs = Array.from(this.inputs).filter(input => 'sizeReveal' in input.dataset);
                    if (sizeRevealerInputs){
                        var d = 'sizeReveal';
                        this.handleHiddenSection(sizeRevealerInputs,d);
                    }
                    var revealerInputs = Array.from(this.inputs).filter(input => 'reveal' in input.dataset);
                    if (revealerInputs) {
                        var d = 'reveal';
                        this.handleHiddenSection(revealerInputs,d)
                    }
                });
            });
        }
    }

    this.handleHiddenSection = function (revealerInputs,datasetName){
        var checkedInputs = revealerInputs.filter(i => i.checked);
        if (!checkedInputs || !checkedInputs.length) {
            revealerInputs.forEach(ri => {
                var section = document.querySelector('[data-controled-by="' + ri.dataset[datasetName] + '"]');
                if (!section) return
                section.classList.add('hidden');
                section.querySelector('.btn-group').setAttribute('data-optional', "");
                section.querySelectorAll('input').forEach(input => {
                    input.setAttribute('name', input.name.replace('properties[', '').replace(']', ''));
                })
            })
        } else {
            checkedInputs.forEach(ci => {
                var section = document.querySelector('[data-controled-by="' + ci.dataset[datasetName] + '"]');
                if (!section) return
                section.classList.remove('hidden');
                section.querySelector('.btn-group').removeAttribute('data-optional');
                section.querySelectorAll('input').forEach(input => {
                    if (!input.getAttribute('name').includes('properties')) {
                        input.setAttribute('name', input.name = 'properties[' + input.name + ']');
                    }
                })
            })
        }
    }

    this._updateVariantSelector = function (event) {
        if (this.element.id !== event.detail.previousGroup.id) {
            return;
        }

        var inputs = this.element.querySelectorAll('input[type="radio"]');
        var checkedOptions = this._getOptionsSelected(inputs);
        console.log(checkedOptions,'🤦‍♂️-----')
        if (this.element.id === 'outfit-group') {
            window.GlobalFormState.setSelectedOutfitOptions(checkedOptions);
        } else {
            window.GlobalFormState.setSelectedAccessoriesOptions(checkedOptions);
        }
        if (!('hasAccessories' in this.element.dataset)) {
            this._matchSelectorOption(window.GlobalFormState.getSelectedOptions());
        } 
    }

    this._matchSelectorOption = function (options) {

       Array.from(this.optionSelector.options).forEach((opt)=> {
            var currentVariantOptions = opt.value.toLowerCase().trim().split('+');
            var areEqual = Utils.arrayEquals(currentVariantOptions, options)
            if (areEqual) {
                setTimeout(function () {
                    opt.selected = true;
                    that.optionSelector.dispatchEvent(new CustomEvent('change'));
                }, 500);
            }
        })
    }

    this._getOptionsSelected = function (inputs) {
        var groupedInputs = Utils.groupBy(Array.from(inputs), 'name');
        var checkedInputs = []
        for (const [_, inputsGroup] of Object.entries(groupedInputs)) {
            var checked = inputsGroup.find(function (input) {
                return input.checked
            })
            if (!checked || 'notIncluded' in checked.dataset) {
                continue;
            }
            var checkedName = checked.name.trim();
            var checkedData = checked.id.split('-')
            var checkedValue = checkedData[checkedData.length - 1];
            if (checkedValue === 'yes') {
                checkedInputs.push(checkedName);
            } else if (checkedValue !== 'no') {
                checkedInputs.push(checkedValue)
            }

        }
        return checkedInputs;
    }
}

function CheckboxesGroupController() {

    this.initialize = function (element) {
        this.element = element;
        this.currentValue = [];
        this.masterInput = this.element.querySelector(settings.selectors.multiselectMasterInput);
        this.inputs = this.element.querySelectorAll('input[type="checkbox"]');
        this._attachListeners();

    }

    this._attachListeners = function () {
        var that = this;
        this.inputs.forEach(function (input) {
            input.addEventListener('change', that._handleChange.bind(that));
        });
    }

    this._handleChange = function (event) {
        var option = event.target.value;

        if (event.target.checked) {
            this._insertOption(option);
        } else {
            this._removeOption(option);
        }

        this._updateSelector();
    }

    this._insertOption = function (option) {
        this.currentValue.push(option)
    }

    this._removeOption = function (option) {
        var index = this.currentValue.indexOf(option);
        if (index > -1) {
            this.currentValue.splice(index, 1);
        }
    }

    this._updateSelector = function () {
        this.masterInput.value = this.currentValue.join().replaceAll(',', ', ');
    }
}

function PurchaseGroupController() {

    this.settings = {
        selectors: {
            sellingPlanButton: 'mystery_box_selling_plan',
            addToCartButtonClone: 'clone_add_to_cart_button',
            addToCartButton: '.ProductForm__AddToCart',
            sellingPlanInput: '[name="selling_plan"]',
            cards: '.price-card',
            appstleSubscriptionWidget: 'appstle_subscription_widget0',
        }
    }

    this.initialize = function (element) {
        this.element = element;
        this.sellingPlanButton = document.getElementById(this.settings.selectors.sellingPlanButton);
        this.addToCartButtonClone = document.getElementById(this.settings.selectors.addToCartButtonClone);
        this.addToCartButton = document.querySelector(this.settings.selectors.addToCartButton);
        this.sellingPlanInput = document.querySelector(this.settings.selectors.sellingPlanInput);
        this.sellingPlanInputParent = this.sellingPlanInput.parentNode;
        this.cards = this.element.querySelectorAll(this.settings.selectors.cards);

        this.sellingPlanButton.addEventListener('click', this.handleSellingPlanClick.bind(this));
        this.addToCartButtonClone.addEventListener('click', this.handleAddToCartClick.bind(this));

        if (this.sellingPlanInput) {
            window.GlobalFormState.setSellingPlanID(this.sellingPlanInput.value)
        }
        this._initializeExpandableContent();

    }

    this._initializeExpandableContent = function () {
        this.cards.forEach(function (card) {
            new ExpandableContent().initialize(card)
        }.bind(this));
    }

    this.handleSellingPlanClick = function (event) {
        if (!this.sellingPlanInput.name) {
            this.sellingPlanInput.value = window.GlobalFormState.getSellingPlanID();
            this.sellingPlanInput.name = 'selling_plan';
        }
        this.addToCartButton.click();
    }
    this.handleAddToCartClick = function (event) {
        var subscriptionForm = document.getElementById(this.settings.selectors.appstleSubscriptionWidget);
        if (subscriptionForm) {
            subscriptionForm.remove();
        }
        this.sellingPlanInput.value = '';
        this.sellingPlanInput.name = '';
        this.addToCartButton.click();
    }
}

function InputController(element) {

    this.element = element
    this._descriptionToggler = new DescriptionToggler(this.element);
    this._textfieldToggler = new TextfieldToggler(this.element);


    this.listenToChange = function (callback) {
        this.element.addEventListener('change', callback);
    }

    this.toggleDescription = function (state) {
        this._descriptionToggler.toggle(state);
    }

    this.toggletextfield = function (state) {
        this._textfieldToggler.toggle(state);
    }

}

function DescriptionToggler(element) {
    this.element = element;
    this.id = element.id;
    this.description = document.querySelector('[data-description-for="' + this.element.id + '"]');

    this.toggle = function (state) {
        if (this.description) {
            if (state === 'open') {
                this.description.classList.remove('hidden');
            } else {
                this.description.classList.add('hidden');
            }
        }
    }

}

function TextfieldToggler(element) {

    this.element = element;
    this.textfield = Utils.createTextfield({ name: 'properties[Style Description]', placeholder: 'Tell us more...' });
    this.wrapper = document.querySelector('[data-extra-info]')

    this.toggle = function (el) {
        if ('includeTextfield' in el.dataset) {
            this.wrapper.appendChild(this.textfield);
            this.textfield.classList.remove('hidden');
            return;
        }
        var textfield = this.wrapper.querySelector('textarea');
        if (textfield) {
            textfield.classList.add('hidden');
            textfield.remove();
        }
    }

}

function FormValidator() {

    var that = this;
    this._invalidGroups = [];

    this.validate = function (group) {

        this._invalidGroups = [];
        var inputs = group.querySelectorAll('input');

        // if there are no inputs it means that we're on the add to cart group,
        // hence nothing to validate
        if (!inputs) {
            return true
        }

        var groupedInputs = Utils.groupBy(Array.from(inputs), 'name');
        var groupsState = [];
        for (const [_, inputsGroup] of Object.entries(groupedInputs)) {
            var inputsGroupWrapper = inputsGroup[0].closest('.btn-group');
            if(!inputsGroupWrapper) continue
            // var inputs = Array.from(inputsGroupWrapper.querySelectorAll('input'));        
            // || inputs.every(function (i) { return i.disabled === true })    
            if ((settings.attributes.inputsOptional in inputsGroupWrapper.dataset)) {
                continue
            }
            enabledInputsGroup = this._filterDisabledInputs(inputsGroup);
            if (!enabledInputsGroup.length) {
                continue
            }
            var state = this._checkIfGroupIsChecked(enabledInputsGroup);
            groupsState.push(state);
            if (!state) {
                this._invalidGroups.push(enabledInputsGroup);
            }
        }
        return groupsState.every(function (e) {
            return e === true;
        });
    }

    this.getInvalidGroups = function () {
        return this._invalidGroups;
    }

    this._filterDisabledInputs = function (inputs) {
        return inputs.filter(function (e) {
            return !e.disabled;
        })
    }

    this._checkIfGroupIsChecked = function (group) {
        return group.some(function (e) { return e.checked; })
    }

    this._removeAnimation = function (e) {
        this.classList.remove('bounce')
        this.removeEventListener('animationend', this._removeAnimation);
    }

    this.animateInvalidInputs = function () {
        var animationDelay = 30
        this._invalidGroups.forEach(function (group) {
            group.forEach(function (input, index) {
                var label = input.nextElementSibling;
                setTimeout(function () {
                    label.classList.add(settings.classes.invalidFieldsAnimation);
                    label.addEventListener('animationend', that._removeAnimation);
                }, (index * 50) + animationDelay);
            });
        })

    }

}

function FormGroupPaginator() {

    this.button = document.querySelector(settings.selectors.paginationButton);
    this.backButton = document.querySelector(settings.selectors.paginationBackButton);

    this.init = function (groups) {
        this.validator = new FormValidator()
        this.button.addEventListener('click', this._handleClick.bind(this));
        this.backButton.addEventListener('click', this._handleReturn.bind(this));
        this.groups = groups;
        this._setCurrentGroupByIndex(0)
        this.groups[0].classList.remove('hidden');
        document.addEventListener('group:switch', this._showBackButton.bind(this));
    }

    this._setCurrentGroupByIndex = function (index) {
        this.currentIndex = index;
        this.currentGroup = this.groups[this.currentIndex];
    }

    this._handleClick = function () {
        if (this.validator.validate(this.currentGroup)) {
            this._showNextGroup();
        } else {
            this.validator.animateInvalidInputs()
        }
    }

    this._handleReturn = function () {
        var nextIndex = this.currentIndex - 1;
        if (nextIndex === 0) {
            this.backButton.classList.add('hidden');
        }
        if (this.button.classList.contains('hidden')) {
            this.button.classList.remove('hidden')
        }
        this._toggleGroupsUI(nextIndex);
        this._setCurrentGroupByIndex(nextIndex);
    }

    this._showBackButton = function (event) {
        if (this.currentIndex === 1) {
            this.backButton.classList.remove('hidden');
        } else if (this.currentIndex === 0) {
            this.backButton.classList.add('hidden');
        }
        // document.removeEventListener('style:selected', this._showButton.bind(this));
    }

    this._showNextGroup = function () {
        var nextIndex = this.currentIndex + 1;
        var groupsLength = this.groups.length
        if (nextIndex < groupsLength) {
            this._toggleGroupsUI(nextIndex);
            this._setCurrentGroupByIndex(nextIndex);
            document.dispatchEvent(new CustomEvent(
                'group:switch', {
                detail: {
                    group: this.currentGroup,
                    previousGroup: this.groups[nextIndex - 1]
                }
            }))
        }
    }

    this._toggleGroupsUI = function (next) {
        if (next === this.groups.length - 1) {
            this.button.classList.add('hidden');
        }
        this.currentGroup.classList.add('hidden');
        this.groups[next].classList.remove('hidden');
    }


}

function CustomVariantSelector() {

    this.settings = {
        selectors: {
            productData: '[data-product-json]',
            priceElement: '[data-mystery-box-price]',
            discountedPriceElement: '[data-mystery-box-price-discounted]',
            lowestPriceElement: '.product-lowest-price',
            sellingPlanInput: '[name="selling_plan"]',
        }
    }

    var that = this;

    this.initialize = function () {
        this.product = JSON.parse(document.querySelector(this.settings.selectors.productData).textContent).product;
        this.priceElement = document.querySelector(this.settings.selectors.priceElement);
        this.discountedPriceElement = document.querySelector(this.settings.selectors.discountedPriceElement);
        this.lowestPriceElement = document.querySelector(this.settings.selectors.lowestPriceElement);
        this.sellingPlanInput = document.querySelector(this.settings.selectors.sellingPlanInput);

        document.addEventListener('custom-variant:changed', this._updateVariant.bind(this))
    }

    this._updateVariant = function (e) {
        this.product.variants.forEach(function (v) {
            if (v.option1 === e.detail.variant) {
                that._updateLowestPrice(v);
                that._updateProductPrice(v);
                that._updateProductDiscountedPrice(v);
                that._updateSellingPlan(v);
                setTimeout(function () {
                    that._updateHistoryState(v);
                }, 250);
            }
        });
    }

    this._updateHistoryState = function (variant) {
        if (!history.replaceState) {
            return;
        }
        var baseURL = window.location.protocol + '//' + window.location.host + window.location.pathname;
        var variantParam = '?variant=' + variant.id;
        var sellingPlanParam = (variant.selling_plan_allocations.length) ? '&selling_plan=' + variant.selling_plan_allocations[0].selling_plan_id : ''
        var newUrl = baseURL + variantParam + sellingPlanParam;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    this._updateLowestPrice = function (variant) {
        var discountedPrice = this._getDiscountedPrice(variant);
        this.lowestPriceElement.innerHTML = 'From ' + this._formatMoney(discountedPrice, window.theme.moneyFormat);
    }

    this._updateProductPrice = function (variant) {
        if (!variant) {
            this.priceElement.style.display = 'none';
        } else {
            this.priceElement.innerHTML = '';
            this.priceElement.innerHTML += this._formatMoney(variant['price'], window.theme.moneyFormat);
            this.priceElement.style.display = '';
        }
    }

    this._updateProductDiscountedPrice = function (variant) {
        if (!variant) {
            this.discountedPriceElement.style.display = 'none';
            return
        }
        this.discountedPriceElement.innerHTML = '';
        var discountedPrice = this._getDiscountedPrice(variant)
        this.discountedPriceElement.innerHTML += this._formatMoney(discountedPrice, window.theme.moneyFormat);
    }

    this._getDiscountedPrice = function (variant) {
        return (!variant.selling_plan_allocations.length) ?
            variant.price :
            variant.selling_plan_allocations[0].price;
    }

    this._formatMoney = function (cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ',');
            decimal = defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
            return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
            //return formatString.replace(placeholderRegex, value).replace('.00', '');
            return formatString.replace(placeholderRegex, value).replace('', '');
        }
    }

    this._updateSellingPlan = function (variant) {
        if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
            this.sellingPlanInput.value = variant.selling_plan_allocations[0].selling_plan_id
            window.GlobalFormState.setSellingPlanID(this.sellingPlanInput.value)
        }
    }

}

function ExpandableContent() {

    this.selectors = {
        toggle: '[data-action="disclosure"]',
        toggleText: '.disclosure-btn__text-content',
    }

    this.initialize = function (element) {
        this.element = element;
        this.toggle = this.element.querySelector(this.selectors.toggle);
        if (!this.toggle) {
            return;
        }
        this.toggleTextContent = this.toggle.querySelector(this.selectors.toggleText);
        this.toggle.addEventListener('click', this._handleToggle.bind(this));
    }

    this._handleToggle = function (e) {
        e.preventDefault();
        this.element.classList.toggle('closed');
        this.toggleTextContent.textContent = this.element.classList.contains('closed') ? 'Learn More' : 'Show less'

    }
}

(function MysteryBox() {
    var groups = document.querySelectorAll('.form-group');
    if (!groups) {
        return;
    }
    var mux = new GroupMux(groups);
    mux.initializeInstance(new StyleGroupController(), 'style-group');
    mux.initializeInstance(new SizeGroupController(), 'size-group');
    mux.initializeInstance(new OutfitGroupController(), 'outfit-group');
    mux.initializeInstance(new OutfitGroupController(true), 'accessories-group');
    mux.initializeInstance(new CheckboxesGroupController(), 'brands-group');
    // mux.initializeInstance(new CheckboxesGroupController(), 'colours-group');
    mux.initializeInstance(new PurchaseGroupController(), 'purchase-group');

    new FormGroupPaginator().init(groups);
    new CustomVariantSelector().initialize();
})();
var elements = document.querySelectorAll('.removeSelector');
  elements.forEach(function(element) {
      element.parentNode.removeChild(element);
  });
// (function MysteryBoxSlider() {
//     var buttonGroup = document.getElementById('style-group');
//     if (!buttonGroup) {
//         return;
//     }
//     var buttons = buttonGroup.querySelectorAll('.product-slide-nav-button');

//     buttons = fizzyUIUtils.makeArray(buttons);

//     var totalThumbnails = fizzyUIUtils.makeArray(document.querySelectorAll('[data-style-group-nav]'));
//     var $slides = document.querySelectorAll('[data-style-group]');
//     if (!$slides) {
//         return
//     }
//     var totalSlides = fizzyUIUtils.makeArray($slides).map(x => x);
//     var initialStyle = buttons[0].dataset.relatedMedia
//     // var initialStyle = buttons[0].getAttribute('for')

//     var slidesToHide = totalSlides.filter(s => s.dataset.styleGroup !== initialStyle)
//     var slidesToShow = totalSlides.filter(s => s.dataset.styleGroup === initialStyle)
//     var thumbnailsToHide = totalThumbnails.filter(t => t.dataset.styleGroupNav !== initialStyle)

//     if (slidesToHide.length !== totalSlides.length) {
//         window.mysteryBoxSliderInstance.remove(slidesToHide);
//         thumbnailsToHide.forEach(t => t.style.display = 'none');
//         updateImagePosition(slidesToShow);
//     }

//     buttonGroup.addEventListener('click', function (event) {
//         if (!matchesSelector(event.target, '.product-slide-nav-button')) {
//             return;
//         }
//         var selectedSlide = event.target.dataset.relatedMedia;
//         // var selectedSlide = event.target.getAttribute('for');

//         var currentSlides = document.querySelectorAll('[data-style-group]');

//         var thumbnailsToShow = totalThumbnails.filter(t => t.dataset.styleGroupNav === selectedSlide);
//         var slideToShow = totalSlides.filter(s => s.dataset.styleGroup === selectedSlide);

//         if (!thumbnailsToShow.length) {
//             showThumbnails(totalThumbnails)
//             selectThumbnail(totalThumbnails[0])
//         } else {
//             hideThumbnails(totalThumbnails)
//             showThumbnails(thumbnailsToShow)
//             selectThumbnail(thumbnailsToShow[0])
//         }

//         window.mysteryBoxSliderInstance.remove(currentSlides);
//         window.mysteryBoxSliderInstance.append(slideToShow.length ? slideToShow : totalSlides);
//         updateImagePosition(slideToShow.length ? slideToShow : totalSlides);


//         // window.mysteryBoxSliderInstance.selectCell('[data-style-group="' + selectedSlide + '"]');
//     });

//     function updateImagePosition(slides) {
//         slides.forEach(function (slide, index) {
//             slide.dataset.imagePosition = index
//         })
//     }

//     function hideThumbnails(thumbnails) {
//         thumbnails.forEach(t => {
//             t.style.display = 'none'
//             t.classList.remove('is-selected');
//         });
//     }

//     function showThumbnails(thumbnails) {
//         thumbnails.forEach(t => t.style.display = 'inline-block');
//     }

//     function selectThumbnail(thumbnail) {
//         thumbnail.classList.add('is-selected');
//     }


// })();